import styled from 'styled-components';

import { Textarea } from '@xsolla/ui-core';

import { CollapseAnimationStyles } from '../../../styled';

export const SmsCustomizeContentBox = styled.div<{ contentHeight: number }>`
  ${(props) => CollapseAnimationStyles(props.contentHeight)};
  padding: ${(props) => (props.contentHeight ? '24px 24px 24px' : '0 24px')};
`;

export const SmsCustomizationTitle = styled.h2`
  ${(props) => props.theme.typography.subHeader2};
  margin-bottom: 8px;
  display: flex;
`;

export const FieldLabel = styled.p`
  ${(props) => props.theme.typography.description};
  color: ${(props) => props.theme.colors.muted};
`;

export const SmsTemplateWrapper = styled.div`
  background: rgba(0, 115, 247, 0.04);
  border: 1px solid ${(props) => props.theme.colors.brand};
  box-sizing: border-box;
  border-radius: ${(props) => props.theme.misc.borderRadiusMd};
  margin-bottom: 32px;
  padding: 25px 32px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const TemplateIconWrapper = styled.div<{ isOpenContent: boolean }>`
  transition: transform 0.15s ease-out;
  color: ${(props) => props.theme.colors.brand};
  border: 2px solid ${(props) => props.theme.colors.brand};
  border-radius: 100%;
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  margin-right: 12px;
  ${(props) => !props.isOpenContent && 'transform: rotate(180deg)'};
`;

export const TextareaWrapper = styled.div`
  div {
    max-width: none;
  }
`;

export const StyledTextarea = styled(Textarea)`
  min-height: 103px;
`;

export const PWrapper = styled.p`
  margin-top: 24px;
`;

export const SmsTemplateContent = styled.div`
  margin-bottom: 48px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SmsTemplateTitle = styled.div`
  ${(props) => props.theme.typography.subHeader2};
  margin-bottom: 8px;
`;

export const SmsContentBlock = styled.div`
  max-width: 684px;
`;
